<template>
  <div class="search">
    <span v-if="!activeFlag && searchText == ''" class="search_img">
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.40606 0.25C6.38603 0.249892 7.34574 0.52905 8.17277 1.05477C8.99979 1.58049 9.65987 2.331 10.0757 3.21838C10.4915 4.10576 10.6458 5.09326 10.5206 6.0652C10.3954 7.03714 9.99574 7.95326 9.36856 8.70625L12.9248 12.2625C12.9865 12.3198 13.0316 12.3927 13.0554 12.4735C13.0791 12.5542 13.0807 12.6399 13.0598 12.7215C13.039 12.8031 12.9965 12.8775 12.9369 12.937C12.8772 12.9964 12.8027 13.0387 12.7211 13.0594C12.6396 13.0803 12.554 13.0788 12.4732 13.0552C12.3925 13.0315 12.3196 12.9865 12.2623 12.925L8.70606 9.36875C8.0697 9.8986 7.3151 10.2674 6.50607 10.4439C5.69705 10.6205 4.8574 10.5996 4.05816 10.383C3.25892 10.1664 2.52359 9.76057 1.91438 9.19971C1.30517 8.63886 0.840004 7.93953 0.558218 7.16089C0.276433 6.38224 0.186323 5.54719 0.295511 4.72635C0.404699 3.90552 0.709972 3.12305 1.18551 2.44515C1.66105 1.76724 2.29286 1.21384 3.0275 0.831743C3.76214 0.44965 4.57799 0.250109 5.40606 0.25ZM1.18731 5.40625C1.18731 5.96026 1.29643 6.50885 1.50844 7.0207C1.72045 7.53254 2.0312 7.99761 2.42295 8.38936C2.8147 8.7811 3.27977 9.09186 3.79161 9.30387C4.30345 9.51588 4.85204 9.625 5.40606 9.625C5.96007 9.625 6.50866 9.51588 7.0205 9.30387C7.53235 9.09186 7.99742 8.7811 8.38917 8.38936C8.78091 7.99761 9.09166 7.53254 9.30368 7.0207C9.51569 6.50885 9.62481 5.96026 9.62481 5.40625C9.62481 4.28737 9.18034 3.21431 8.38917 2.42314C7.598 1.63197 6.52494 1.1875 5.40606 1.1875C4.28718 1.1875 3.21412 1.63197 2.42295 2.42314C1.63178 3.21431 1.18731 4.28737 1.18731 5.40625Z"
          fill="#A2A2A2"
        />
      </svg>
    </span>
    <el-input
      :class="activeFlag || searchText != '' ? 'active' : ''"
      :placeholder="
        activeFlag
          ? $t('app.search_placeholder.active')
          : $t('app.search_placeholder.default')
      "
      v-model="searchText"
      @focus="focus"
      @blur="inputBlur"
    >
    </el-input>
    <div @click="clearSearch" class="search__clear" v-if="searchText">
      <i class="el-icon-close"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventEmitter } from "../../main";
import busListeners from "@/mixins/busListeners";

// Поиск перебирает все задачи и перерисовывает выдачу — не делаем это на каждую клавишу
export const SEARCH_DEBOUNCE_MS = 250;

export default {
  name: "SearchTasks",
  mixins: [busListeners],
  data() {
    return {
      searchText: "",
      activeFlag: false,
    };
  },
  mounted() {
    this.busOn("SearchInputClear", (data) => {
      if (data) {
        this.searchText = "";
        this.activeFlag = false;
      }
    });

    this.busOn("SearchTasksSync", () => {
      if (this.searchText) this.emitSearch(this.searchText);
    });
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  methods: {
    scheduleSearch(value) {
      clearTimeout(this.searchTimer);
      // очистку применяем сразу, чтобы не мигала старая выдача
      if (value == "") {
        this.emitSearch(value);
        return;
      }
      this.searchTimer = setTimeout(
        () => this.emitSearch(value),
        SEARCH_DEBOUNCE_MS
      );
    },
    emitSearch(value) {
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
      EventEmitter.$emit("SearchTasksProject", value);
    },
    clearSearch(e) {
      this.searchText = "";
      this.activeFlag = false;
      this.$router.push("/no-lists").catch(() => true);
      EventEmitter.$emit("SearchInputFocus", true);
    },
    inputBlur() {
      this.activeFlag = false;
      if (this.searchText == "") {
        this.$router.push("/no-lists").catch(() => true);
        EventEmitter.$emit("SearchInputFocus", true);
      }
    },
    focus() {
      this.activeFlag = true;
      EventEmitter.$emit("SearchInputFocus", false);
    },
  },
  watch: {
    searchText(value) {
      this.scheduleSearch(value);
      if (value && this.$route.path != "/search") {
        this.$router.push("/search").catch(() => true);
      }
    },
  },
  computed: {
    ...mapGetters(["getTasks", "getProjects"]),
  },
};
</script>
